var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatbotinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.73 44.73"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".chatbot_inline_svg__cls-2{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chatbot_inline_svg__Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chatbot_inline_svg__Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chatbot_inline_svg__Grupo_17",
    "data-name": "Grupo 17"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "chatbot_inline_svg__Elipse_3",
    "data-name": "Elipse 3",
    cx: 22.36,
    cy: 22.36,
    r: 22.36,
    fill: "#80c342"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chatbot_inline_svg__cls-2",
    d: "M33.66 22.65v-.33a4.82 4.82 0 00-4.81-4.82h-5.71v-2.05a3 3 0 10-1.55 0v2.05h-5.71a4.82 4.82 0 00-4.82 4.82v.33a4.08 4.08 0 000 8 4.82 4.82 0 004.81 4.58h13a4.83 4.83 0 004.81-4.58 4.08 4.08 0 000-8zm-22.6 6.41a2.53 2.53 0 010-4.81zm9.83-16.54A1.48 1.48 0 1122.36 14a1.47 1.47 0 01-1.47-1.48zm11.22 17.9a3.27 3.27 0 01-3.26 3.27h-13a3.27 3.27 0 01-3.26-3.27v-8.1a3.27 3.27 0 013.26-3.27h13a3.27 3.27 0 013.26 3.27zm1.55-1.36v-4.81a2.53 2.53 0 010 4.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chatbot_inline_svg__cls-2",
    d: "M28 22.39a2.29 2.29 0 102.29 2.29A2.29 2.29 0 0028 22.39zm0 3a.74.74 0 11.74-.73.74.74 0 01-.74.75zM16.71 22.39A2.29 2.29 0 1019 24.68a2.28 2.28 0 00-2.29-2.29zm0 3a.74.74 0 11.73-.73.74.74 0 01-.73.75zM24.48 29.37h-4.23a.78.78 0 100 1.56h4.23a.78.78 0 000-1.56z"
  }))))));
}

export default SvgChatbotinline;